import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Clubs from "./pages/ClubsList";
import SingleClub from "./pages/Club";
import Header from "./components/navigation/Header";
import GameBar from "./components/gamebar/GameBar";
import Footer from "./components/core/Footer";
import SinglePlayer from "./pages/Player";
import GameCentre from "./pages/Gamecentre";
import Game from "./pages/Game";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import NotFound from "./pages/404";
import Division from "./pages/Division";
import News from "./pages/News";
import Education from "./pages/Education";
import MdcontentPage from "./pages/MdcontentPage";
// import GBS from "./pages/GBS";
import ScrollToTop from "./components/core/ScrollToTop";
import { Helmet } from "react-helmet-async";
import ErrorBoundary from "./components/core/ErrorBoundary";
import TitoPage from "./pages/TitoPage";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <BrowserRouter>
          <Header />
          <GameBar />
          <Helmet>
            <meta name="robots" content="index, follow" />
          </Helmet>
          <ScrollToTop />
          <Routes>
            <Route path="*" element={<NotFound />} />
            <Route path="/clubs" element={<Clubs />} />
            <Route path="/club/:clubId/:tab" element={<SingleClub />} />
            <Route path="/club/:clubId" element={<SingleClub />} />
            <Route path="/game/:gameId" element={<Game />} />
            <Route path="/game/:gameId/:tab" element={<Game />} />
            <Route path="/" element={<Home />} />
            <Route path="/player/:playerId" element={<SinglePlayer />} />
            <Route path="/gamecentre" element={<GameCentre />} />
            <Route path="/gamecentre/:tab" element={<GameCentre />} />
            <Route path="/gamecenter" element={<GameCentre />} />
            <Route path="/gamecenter/:tab" element={<GameCentre />} />
            <Route path="/division/:divisionId/:tab" element={<Division />} />
            <Route path="/division/:divisionId" element={<Division />} />
            <Route path="/news/:newsId" element={<News />} />
            
            {/*<Route path="/gbs" element={<GBS />} />
            <Route path="/gbs/:tab" element={<GBS />} />*/}
            
            <Route path="/education" element={<Education />} />
            <Route
              path="/approach"
              element={<MdcontentPage mdfile="approach" />}
            />
            <Route
              path="/history"
              element={<MdcontentPage mdfile="history" />}
            />
            {/*<Route*/}
            {/*    path="/merchandise"*/}
            {/*    element={<TitoPage mdfile="merchandise" />}*/}
            {/*/>*/}
            <Route
              path="/body-contact"
              element={<MdcontentPage mdfile="bodycontact" />}
            />
            <Route
              path="/contributors"
              element={<MdcontentPage mdfile="contributors" />}
            />
            <Route path="/skills" element={<MdcontentPage mdfile="skills" />} />
            <Route
              path="/injury-prevention"
              element={<MdcontentPage mdfile="injury-prevention" />}
            />
            <Route path="/gdpr" element={<MdcontentPage mdfile="gdpr" />} />
            {/*<Route path="/camps" element={<MdcontentPage mdfile="camps" />} />*/}

            {/* Alias routes */}
            <Route path="/g/:gameId" element={<Game />} />
            <Route path="/g/:gameId/:tab" element={<Game />} />
            <Route path="/p/:playerId" element={<SinglePlayer />} />

            <Route path="/div/:divisionId/:tab" element={<Division />} />
            <Route path="/div/:divisionId" element={<Division />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;
